var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.__('Integração Zapier')))]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"https://zapier.com/developer/public-invite/146311/9700ab369510cf720cd2c86665f25590/","target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.__('Clique aqui para configurar a integração.'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }